import InterBoldText from './InterBoldText';

export default InterBoldText;
